import { Typography, Link, Grid, styled } from '@mui/material'
import OrderwireLogo from '../components/OrderwireLogo'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { useCreateCompanyContext } from '../CreateCompanyContext'
import NextButton from './NextButton'

const WhiteTypography = styled(Typography)({
    color: 'white',
    textTransform: 'none',
})

function GreetAndWelcome() {
    const { isMobile } = useScreenSize()
    const { t } = useTranslation()
    const { onNext } = useCreateCompanyContext()
    const handleOnNext = () => {
        onNext()
    }
    const history = useHistory()
    const handleBackToHomepage = () => {
        history.goBack()
    }

    return (
        <>
            <Grid item container direction="column" p={1} height={'100vh'}>
                <Grid
                    item
                    container
                    direction="column"
                    sx={{
                        textAlign: 'center',
                    }}
                    height={'100%'}
                >
                    <Grid item mb={4}>
                        <OrderwireLogo />
                    </Grid>

                    <Grid
                        item
                        container
                        direction="column"
                        spacing={2}
                        px={1}
                        flexGrow={3}
                        justifyContent="center"
                    >
                        <Grid item>
                            <WhiteTypography variant={isMobile ? 'h5' : 'h4'}>
                                {t('register.label.welcome_text')}
                            </WhiteTypography>
                        </Grid>

                        <Grid item>
                            <WhiteTypography variant={isMobile ? 'h5' : 'h4'}>
                                {t('register.label.invite_text')}
                            </WhiteTypography>
                        </Grid>

                        <Grid item>
                            <NextButton
                                text={t('register.button.label.start')}
                                onClick={handleOnNext}
                            />
                        </Grid>
                    </Grid>

                    <Grid item mt={4} flexGrow={1}>
                        <Link
                            component="button"
                            underline="hover"
                            variant="body1"
                            onClick={() => handleBackToHomepage()}
                            color="white"
                        >
                            <Typography variant="subtitle1">
                                {t('register.label.back_to_home_page')}
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default GreetAndWelcome
